import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"

export const StyledCard = styled(Card)`
  width: 227px;
`
